'use client'

import { useMemo, type ReactNode } from 'react'
import { NextIntlClientProvider, useLocale, useMessages } from 'next-intl'
import { mergeMessageTrees } from '@/lib/i18n/client-messages'

/**
 * Adds the admin namespaces to the messages the root provider already holds
 * (ALU-662). A nested provider replaces `messages` instead of extending them,
 * so this one reads the parent's and merges. Everything else (time zone, now,
 * formats, error handlers) is inherited from the parent by use-intl.
 */
export function AdminMessagesClient({
  messages,
  children,
}: {
  messages: Record<string, unknown>
  children: ReactNode
}) {
  const locale = useLocale()
  const parent = useMessages() as Record<string, unknown>
  const merged = useMemo(() => mergeMessageTrees(parent, messages), [parent, messages])
  return (
    <NextIntlClientProvider locale={locale} messages={merged}>
      {children}
    </NextIntlClientProvider>
  )
}
